import { humanize } from './review-edit-events';

// Display labels for fields of the live Financials rows embedded in the Review panel. Unlisted
// fields fall back to a humanized field name, so a new field is never silently dropped.
const ROW_FIELD_LABELS = {
  consideration: {
    consideration_type: 'Consideration Type',
    total_units: 'Period',
    amount: 'Rent ($)',
    commission_percent: 'Commission Rate',
    commission_amount: 'Commission',
  },
  additional_commission: {
    acommission_type: 'Commission Type',
    total_units: 'Quantity',
    amount: 'Amount ($)',
  },
  broker_commission: {
    broker: 'Broker',
    voucher_broker_rep_role: 'Rep Role',
    producer_role: 'Producer Role',
    broker_is_lead: 'Lead Producer',
  },
  office_commission: {
    deptid: 'Functional Unit',
    officename: 'Managing Office Code',
    voucher_office_allocation_name: 'Managing Office',
    voucher_office_client_name: 'Client Name',
    producer_role: 'Producer Role',
  },
  pool_commission: {
    voucher_cbre_pool_name: 'Pool Account',
    producer_role: 'Producer Role',
  },
  installment: {
    voucher_contingency_code: 'Due Upon',
    installment_date: 'Installment Date',
  },
  outside_broker: {
    partner: 'CBRE Affiliate',
    paid_by_cbre: 'Paid By CBRE',
    voucher_broker_rep_role: 'Rep Role',
    outside_broker_name: 'Full Name',
    license_code: 'License Code',
    license_expdt: 'License Expiration Date',
  },
  outside_broker_vendor: {
    name: 'Company',
    address: 'Address',
    address2: 'Address Line 2',
    city: 'City',
    territory: 'State',
    country: 'Country',
    postal: 'Zip',
  },
  tax_allocation: { tax_allocation_name: 'Tax' },
  bill_to: { billed_to_type: 'Billed To' },
  other_contact: {
    given_name: 'First Name',
    surname: 'Last Name',
    phone: 'Phone Number',
    email: 'Email',
    job_title: 'Job Title',
  },
  bill_to_company: {
    name: 'Company Name',
    voucher_naics_code: 'Business Type Code',
    voucher_naics_category: 'Business Type / Use ID',
    address: 'Address',
    address2: 'Address Line 2',
    city: 'City',
    territory: 'State',
    country: 'Country',
    postal: 'Zip',
  },
  fee_sharing: {
    voucher_from_dept: 'From',
    voucher_to_dept: 'To LOB',
  },
  rebate: { rebate_client_name: 'PRV - Client Name' },
};

const toSnakeCase = value => value.replace(/([A-Z])/g, '_$1').toLowerCase();

const getRowFieldLabel = (rowType, fieldName) => ROW_FIELD_LABELS[rowType]?.[fieldName] || humanize(fieldName);

export { ROW_FIELD_LABELS, toSnakeCase, getRowFieldLabel };
